export default __webpack_public_path__ + "static/media/videoResourceIcon.042c4254.svg";